module.exports = __webpack_public_path__ + "media/application/images/ui/price-spy-9026355fc47b96e97bdb05d719078ea4.svg";